import { getErrorObjectsList } from '@shared/utils/helpers';
import { ErrorMessageStrategy, ResponseError } from '@shared/utils/interfaces';

export const forceUpdateNotificationsFailedStrategy: ErrorMessageStrategy = (error: ResponseError) => ({
  translationKey: 'errors.FORCE_UPDATE_NOTIFICATIONS_FAILED',
  translationParams: {
    engines: getErrorObjectsList(error),
  },
});
